import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import RouteError from 'pages/error/RouteError';
import GuestGuard from 'utils/route-guard/GuestGuard';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const ConfirmRegistrationPage = Loadable(lazy(() => import('pages/auth/ConfirmRegistration')));
const ForgotPasswordPage = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPasswordPage = Loadable(lazy(() => import('pages/auth/ResetPassword')));
const ChangePinPage = Loadable(lazy(() => import('pages/auth/ChangePin')));
const CompleteInvitePage = Loadable(lazy(() => import('pages/auth/CompleteInvite')));
const SignatureConfirmPage = Loadable(lazy(() => import('pages/auth/SignatureConfirm')));
const ConfirmPrivateEmailPage = Loadable(lazy(() => import('pages/auth/ConfirmPrivateEmail')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  errorElement: <RouteError />,
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          )
        },
        {
          path: '/register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          )
        },
        {
          path: '/confirm-registration',
          element: (
            <GuestGuard>
              <ConfirmRegistrationPage />
            </GuestGuard>
          )
        },
        {
          path: '/forgot-password',
          element: (
            <GuestGuard>
              <ForgotPasswordPage />
            </GuestGuard>
          )
        },
        {
          path: '/reset-password',
          element: (
            <GuestGuard>
              <ResetPasswordPage />
            </GuestGuard>
          )
        },
        {
          // No guard - the "Změnit PIN" link is opened by an already-
          // authenticated user (requesting it required a session), unlike
          // the other auth routes above which are logged-out-only.
          path: '/change-pin',
          element: <ChangePinPage />
        },
        {
          path: '/complete-invite',
          element: (
            <GuestGuard>
              <CompleteInvitePage />
            </GuestGuard>
          )
        },
        {
          // No guard, same reasoning as /change-pin - opened from a mailed
          // link that may or may not have an active session, and the
          // confirm endpoint itself is public/token-based either way.
          path: '/signature-confirm',
          element: <SignatureConfirmPage />
        },
        {
          // No guard, stejný důvod jako /change-pin a /signature-confirm.
          path: '/confirm-private-email',
          element: <ConfirmPrivateEmailPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
